import { render, staticRenderFns } from "./CustomerServiceContact.vue?vue&type=template&id=cf6ad1be&scoped=true"
import script from "./CustomerServiceContact.vue?vue&type=script&lang=js"
export * from "./CustomerServiceContact.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceContact.vue?vue&type=style&index=0&id=cf6ad1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6ad1be",
  null
  
)

export default component.exports